export const API_PATHS = {
  FETCH_LATEST_PRODUCTS: '/api/products/latest',
  FETCH_PRODUCT_BY_SLUG: (slug: string) => `/api/products/slug/${slug}`,
  FETCH_PRODUCTS_BY_CATEGORY: (category: string) => `/api/products?category=${category}`,
  FETCH_PRODUCT_COUNTS: '/api/products/counts',
};
